/**
 * The complete inventory of what this site stores in a visitor's browser.
 *
 * This is the single source for both docs/cookies.md and the table rendered on
 * /soukromi. Nothing may be stored that is not listed here — adding a key
 * without adding a row makes the privacy notice false, which is the failure
 * mode this file exists to prevent.
 */
export interface StorageRow {
  key: string;
  type: string;
  purpose: string;
  lifetime: string;
  consent: string;
}

export const STORAGE_INVENTORY: StorageRow[] = [
  {
    key: 'vote_id',
    type: 'Cookie — HttpOnly, SameSite=Strict, Secure, podepsaná',
    purpose: 'Anonymní rozlišení hlasujících, aby jeden člověk nehlasoval opakovaně',
    lifetime: '12 měsíců',
    consent: 'Nevyžaduje se — nastavuje se až při prvním hlasování',
  },
  {
    key: 'admin_session',
    type: 'Cookie — HttpOnly, SameSite=Strict, Secure, podepsaná',
    purpose: 'Přihlášení administrátora',
    lifetime: 'Do odhlášení, nejvýše 12 hodin',
    consent: 'Nevyžaduje se — nezbytné pro přihlášení',
  },
  {
    key: 'mapa-cache',
    type: 'IndexedDB',
    purpose: 'Lokální cache podnětů, aby se mapa vrátivšímu se návštěvníkovi zobrazila okamžitě',
    lifetime: '24 hodin',
    consent: 'Nevyžaduje se — ukládá obsah, který jste si vyžádali',
  },
  {
    key: 'notice_seen',
    type: 'localStorage',
    purpose: 'Pamatuje si, že jste informační lištu zavřeli',
    lifetime: '12 měsíců',
    consent: 'Nevyžaduje se — bez něj by se lišta zobrazovala stále dokola',
  },
  {
    key: 'consent_state',
    type: 'localStorage',
    purpose:
      'Záznam vašich voleb v nastavení cookies (verze, čas, jednotlivé kategorie). Vzniká pouze tehdy, je-li vrstva souhlasu zapnutá — dnes není.',
    lifetime: '12 měsíců',
    consent: 'Nevyžaduje se — záznam samotného souhlasu',
  },
];
